import { Shimmer } from '@components';
import { Column } from '../../AssetHistory.styles';

const CountLoading = () => {
  return (
    <Shimmer
      style={{ height: 22, width: 22, borderRadius: 4, marginLeft: 8 }}
      primary="#f1f1f1"
      secondary="#ececec"
    />
  );
};

const AssetHistoryLoading = () => {
  return (
    <Column>
      <Shimmer
        style={{ height: 22, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 22, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 22, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 22, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 22, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 22, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </Column>
  );
};

export { AssetHistoryLoading, CountLoading };
